module.exports = __webpack_public_path__ + "img/icon_work_07.b033a792.png";